export const interiorView11ImageOptions = {
	angle:"InteriorView11",
	staticOptions:{
		PortAftCabinOptions:1,
		Veneer:1,
		Floorboard:1,
		Worktop:1,
		FabricSaloon:1,
		CupboardsOwnersCabin:1,
		Mast:1,
		TableBox:1,
		Pouffes:1,
		FabricCabins:1,
	},
	mattes:[
		{
			option:"Veneer",
			dependency:["StarboardAftCabinOptions", "StarboardAftCabin"]
		},
		{
			option:"FabricCabins",
			dependency:["StarboardAftCabinOptions", "StarboardAftCabin"]
		},
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/InteriorView11.js